import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "ticketino-api-client";
import { motion } from "framer-motion";

import Header from "./components/Header";

import arrowRight from "../images/icons/arrow-right.svg";
import "../css/confirmation-newsletter.css";
import newsletterImg from "../images/newsletter.png";

const Confirmation = () => {
    const { orderId } = useParams();

    const [token] = useState(localStorage.getItem("token"));
    const [order, setOrder] = useState([]);
    const [organizerId, setOrganizerId] = useState(0);
    const [selectedTicketType] = useState(localStorage.getItem("selectedTicketType"));

    const [error, setError] = useState(null);

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching resources
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        // gtm - purchase
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'purchase'
        });
    }, [])

    useEffect(() => {
        loadToken();
    }, []); //only on first page load

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed


    const loadToken = async () => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        localStorage.removeItem("orderId");

        requestFormSettings()
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            setOrganizerId(res.data.organizerId);
            loadOrder(orderId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadOrder = async (orderId, attempt = 1) => {
        try {
            const fetchedOrder = await getOrderByOrderId(orderId);

            // If invoiceNumber missing and attempts < 7, retry
            if ((!fetchedOrder?.invoiceNumber || fetchedOrder.invoiceNumber === "") && attempt < 7) {
                console.log(`Retrying to fetch order... Attempt ${attempt + 1}`);
                await new Promise((resolve) => setTimeout(resolve, 2000)); // optional delay before retry
                return loadOrder(orderId, attempt + 1);
            }

            if (!fetchedOrder?.invoiceNumber) {
                setError("Invoice number is missing after multiple attempts.");
            } else {
                setError(null);
            }

            setOrder(fetchedOrder);
        } catch (error) {
            console.error(error);
            setError("Failed to load order.");
        }
    };

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const getReceiptOfOrder = async () => {
        await axios
            .get(`${baseUrl}/Order/${orderId}/Receipt?organizerId=${organizerId}`, {
                responseType: "blob",
            })
            .then((res) => {
                const data = window.URL.createObjectURL(res.data);
                var link = document.createElement("a");
                link.href = data;
                link.download = "Receipt.pdf";
                link.click();
            })
            .catch((error) => console.error(error.response.data));
    };

    const getPdfTicketsOfOrder = async () => {
        await axios
            .get(
                `${baseUrl}/Order/${orderId}/TicketsPdf?organizerId=${organizerId}`,
                {
                    responseType: "blob",
                }
            )
            .then((res) => {
                const data = window.URL.createObjectURL(res.data);
                var link = document.createElement("a");
                link.href = data;
                link.download = "Tickets.pdf";
                link.click();
            })
            .catch((error) => console.error(error.response.data));
    };

    // Handler for BuyerBookMoreTickets button
    const onBookMoreTickets = async () => {
        window.location.href = resources?.BuyerBookMoreTicketsUrl;
    }

    // open external newsletter registration
    const redirectToExternalNewsletter = () => {
        const url = resources?.RegisterToNewsletterUrl;
        if (url) {
            window.open(url, "_blank", "noopener,noreferrer");
        }
    }

    return (
        <>
            <Header language={language} pagePath="home" />

            {/* Newsletter image top left, closer to center */}
            <div className="newsletter-top-left">
                <img
                    src={newsletterImg}
                    alt="newsletter"
                    className="newsletter-img"
                    onClick={redirectToExternalNewsletter}
                />
            </div>

            <motion.div
                className="page-container"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut", delay: 0.8 }}
            >
                <div className="container wrapper text-center">

                    {/* Show error message if any */}
                    {error && (
                        <div className="row pt-2">
                            <div className="col-md-12">
                                <div className="alert alert-danger" role="alert">
                                    <p dangerouslySetInnerHTML={{ __html: resources?.ErrorOrder?.replaceAll("${orderId}", orderId) }}></p>
                                </div>
                            </div>
                        </div>
                    )}

                    {!error && order && order.invoiceNumber && order.invoiceNumber !== 0 && (
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <h1 className="fs-3">{resources.ConfirmationTitle}</h1>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <div className="mb-4 col-md-12 ">
                                            <p className="mb-2 fs-6">
                                                {resources.Confirmation2}<span className="ms-2 fw-bold fs-6">{order?.invoiceNumber}</span>
                                            </p>
                                            <p className="mb-4 fs-6">
                                                {resources.Confirmation3}<span className="ms-2 fw-bold fs-6">{order?.currency} {order?.totalPrice?.toFixed(2)}</span>
                                            </p>
                                            <p className="mb-0 fs-6">
                                                <span dangerouslySetInnerHTML={{ __html: resources.ConfirmationDesc }}></span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-md-12 mb-4">
                                    <button
                                        className="btn-custom"
                                        onClick={() => getPdfTicketsOfOrder()}
                                    >
                                        {resources.DownloadTicket}
                                    </button>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 mb-4">
                                    <button
                                        className="btn-custom"
                                        onClick={() => getReceiptOfOrder()}
                                    >
                                        {resources.DownloadReceipt}
                                    </button>
                                </div>
                            </div>

                            {/* Book More Tickets Section */}
                            <div className="row mt-5">
                                <div className="col-12 text-end">
                                    <button className="btn-custom-checkout-arrow me-3" onClick={onBookMoreTickets}>
                                        <img src={arrowRight} alt="book more tickets" style={{ marginTop: "-3px", marginLeft: "4px", width: "10px", height: "12px" }} />
                                    </button>
                                    <button className="btn-custom-checkout" onClick={onBookMoreTickets}>
                                        {resources?.BuyerBookMoreTickets}
                                    </button>
                                </div>
                            </div>

                            <div className="row mt-5">
                                <div className="col-md-12 text-center">
                                    <p className="mt-4">
                                        <small style={{ color: 'grey' }}>{resources?.ConfirmationNoteOrderNumberInfo} <a style={{ color: 'grey', textDecoration: 'none' }} href="https://organizer.ticketino.com/de" target="_blank">info@ticketino.com</a>.</small>
                                    </p>
                                </div>
                            </div>

                        </>
                    )}

                    <div className="row mt-1">
                        <div className="col-md-12 text-center">
                            <p>
                                <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none', fontSize: '13px' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                            </p>
                        </div>
                    </div>
                </div>
            </motion.div>
        </>
    )
}

export default Confirmation